import React from 'react';
import { Link } from 'gatsby-plugin-intl';
import { getLinkPrefix } from '../../utils/getLinkPrefix';

export const SideCategoryMenu = ({ categories, langKey, country_code }) => {
  return (
    <ul className="left-side-menu margin-bottom">
      {categories?.map(category => {
        const localized_category = category.localizations.find(item => item.locale === langKey) || category;
        return (
          <li key={category.id}>
            {
              localized_category.external_link ?
                <a href={localized_category.link} title={localized_category.Name}>
                  {localized_category.Name}
                </a>
                :
                <Link to={getLinkPrefix('categories', `${localized_category.link}`)} language={langKey} title={localized_category.Name}>{localized_category.Name}</Link>
            }
          </li>
        )

      })}
    </ul>
  )
}

